export const PAYMENT_ACCOUNT = {
  accountName: 'Tchikamalor Global Nig. Ltd',
  bankName: 'Access Bank',
  accountNumber: '0036483685',
};

export const CUSTOMER_CARE_WHATSAPP = '2349098370120';
export const MANUAL_PAYMENT_METHOD = 'manual_bank_transfer';
